define('views/content/reports/comparison',['require','backbone','marionette','bootstrap-daterangepicker','datatables','text!templates/content/reports/comparison.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('datatables');

    var temp = require("text!templates/content/reports/comparison.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'comparison_reports',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                referenceDateRangePicker: '#reference-range-picker',
                compareDateRangePicker: '#compare-range-picker',

                referenceSalesTable: '.reference .overall-sales-list',
                compareSalesTable: '.compare .overall-sales-list',

                referenceNewResellersTable: '.reference .new-resellers-list',
                compareNewResellersTable: '.compare .new-resellers-list'
            };
        },

        onRender: function () {
            var _this = this;

            this.ui.referenceDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.referenceDateRangePicker.on('hide.daterangepicker', function () {
                if (_this.ui.compareDateRangePicker.data('daterangepicker').startDate &&
                    _this.ui.compareDateRangePicker.data('daterangepicker').endDate) {

                    _this.getReports();
                }
            });

            this.ui.compareDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            this.ui.compareDateRangePicker.on('hide.daterangepicker', function () {
                if (_this.ui.referenceDateRangePicker.data('daterangepicker').startDate &&
                    _this.ui.referenceDateRangePicker.data('daterangepicker').endDate) {

                    _this.getReports();
                }
            });

            var startTime = localStorage.getItem('report_start_time');
            var endTime = localStorage.getItem('report_end_time');
            if (startTime && endTime) {
                this.ui.referenceDateRangePicker.data('daterangepicker').setStartDate(new Date(parseInt(startTime)));
                this.ui.referenceDateRangePicker.data('daterangepicker').setEndDate(new Date(parseInt(endTime)));
            }
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/comparison-reports/',
                method: 'get',
                data: {
                    start_date: this.ui.referenceDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date: this.ui.referenceDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD'),
                    start_date_compare: this.ui.compareDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date_compare: this.ui.compareDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD')
                },
                success: function (response) {
                    _this.showOverallSaleReports(response.sales_report);
                    _this.showNewResellerReports(response.new_resellers_report);
                }
            });
        },

        showOverallSaleReports: function (reportData) {
            // Transform report data for datatables format

            // Reference side
            var referenceGridData = [];

            var referenceTotalRow = {
                count: 0
            };

            reportData.reference.forEach(function (reportRow) {
                referenceGridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    reportRow.count
                ]);

                referenceTotalRow.count += reportRow.count;
            });

            // Add total row
            referenceGridData.push([
                App.polyglot.t('total'),
                referenceTotalRow.count
            ]);

            if (!this.referenceSalesDataTable) {
                this.referenceSalesDataTable = this.ui.referenceSalesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: referenceGridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('count') }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.referenceSalesDataTable.clear();
                this.referenceSalesDataTable.rows.add(referenceGridData);
                this.referenceSalesDataTable.columns.adjust().draw();
            }


            // Compare side
            var compareGridData = [];

            var compareTotalRow = {
                count: 0
            };

            reportData.compare.forEach(function (reportRow) {
                compareGridData.push([
                    '<a href="/products/' + reportRow.product.id + '">' + reportRow.product.name + '<a/>',
                    reportRow.count,
                    $.isNumeric(reportRow.change) ? (reportRow.change.toFixed(2) + ' %') : reportRow.change
                ]);

                compareTotalRow.count += reportRow.count;
            });

            // Add total row
            compareGridData.push([
                App.polyglot.t('total'),
                compareTotalRow.count,
                ''
            ]);

            if (!this.compareSalesDataTable) {
                this.compareSalesDataTable = this.ui.compareSalesTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: compareGridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('count'), className: 'text-right' },
                        { title: App.polyglot.t('change_percentage'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.compareSalesDataTable.clear();
                this.compareSalesDataTable.rows.add(compareGridData);
                this.compareSalesDataTable.columns.adjust().draw();
            }
        },

        showNewResellerReports: function (reportData) {
            // Transform report data for datatables format

            // Reference side
            var referenceGridData = [];

            var referenceTotalRow = {
                count: 0
            };

            reportData.reference.forEach(function (reportRow) {
                referenceGridData.push([
                    (reportRow.key == 'local' ? App.polyglot.t('local') : App.polyglot.t('foreign')),
                    reportRow.count
                ]);

                referenceTotalRow.count += reportRow.count;
            });

            // Add total row
            referenceGridData.push([
                App.polyglot.t('total'),
                referenceTotalRow.count
            ]);

            if (!this.referenceNewResellersDataTable) {
                this.referenceNewResellersDataTable = this.ui.referenceNewResellersTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: referenceGridData,
                    columns: [
                        { title: App.polyglot.t('country') },
                        { title: App.polyglot.t('count'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.referenceNewResellersDataTable.clear();
                this.referenceNewResellersDataTable.rows.add(referenceGridData);
                this.referenceNewResellersDataTable.columns.adjust().draw();
            }


            // Compare side
            var compareGridData = [];

            var compareTotalRow = {
                count: 0
            };

            reportData.compare.forEach(function (reportRow) {
                compareGridData.push([
                    (reportRow.key == 'local' ? App.polyglot.t('local') : App.polyglot.t('foreign')),
                    reportRow.count,
                    $.isNumeric(reportRow.change) ? (reportRow.change.toFixed(2) + ' %') : reportRow.change
                ]);

                compareTotalRow.count += reportRow.count;
            });

            // Add total row
            compareGridData.push([
                App.polyglot.t('total'),
                compareTotalRow.count,
                ''
            ]);

            if (!this.compareNewResellersDataTable) {
                this.compareNewResellersDataTable = this.ui.compareNewResellersTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: compareGridData,
                    columns: [
                        { title: App.polyglot.t('product') },
                        { title: App.polyglot.t('count'), className: 'text-right' },
                        { title: App.polyglot.t('change_percentage'), className: 'text-right' }
                    ],
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.compareNewResellersDataTable.clear();
                this.compareNewResellersDataTable.rows.add(compareGridData);
                this.compareNewResellersDataTable.columns.adjust().draw();
            }
        }

    });
});
